import type { ReactNode } from 'react';
import styles from './OptionList.module.css';

export function OptionList({ children }: { children: ReactNode }) {
  return <div className={styles.list}>{children}</div>;
}
